"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.prospect")
    .config(["$stateProvider", routeConfig]);

function prospectLazyLoad(transition) {
    const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
    return import(
        /* webpackChunkName: "feature-accounting-prospect" */ "./prospect.entry"
    ).then(() => $ocLazyLoad.inject("nucont.accounting.prospect"));
}

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.prospect", {
            url: "/prospects",
            lazyLoad: prospectLazyLoad,
            views: {
                "admin@nucont.accounting": {
                    component: "prospectComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4"
                }
            }
        })
        .state("nucont.accounting.prospect-dashboard", {
            url: "/prospect/:prospectId",
            lazyLoad: prospectLazyLoad,
            params: {
                prospectId: {
                    value: null
                }
            },
            views: {
                "admin@nucont.accounting": {
                    component: "prospectDashboardComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4"
                }
            },
            bodyClass: "prospect-dashboard-module"
        });
}
